<div class="selector-container grid small grid-two"  [ngClass]="showSidebar ? 'd-none' : ''">
  <app-selector *ngFor="let entry of dataEntries; let isFirst = first; let isLast = last" class="finishing"
    [id]="entry.ID" [name]="entry.name | translate" [description]="entry.description | translate"
    [showDescription]="true" [checked]="entry.checked" [image]="entry.image" [isFirst]="isFirst" [isLast]="isLast"
    [isSingleItem]="true" (selected)="onSelectorClicked($event)"></app-selector>
</div>

<app-lateral-panel id="subtitle-info-lateral" class="d-block subtitle-info-lateral primary accordion"
  [extraClasses]="'m-w-768'" [(showSidebar)]="showSidebar">
  <div class="row d-flex justify-content-between align-items-center button-row exit-row panel-title">
    <h3 class="primary m-b-question m-t-question" [innerHTML]="'b2c.IDS_FINISHING_GUIDE' | translate"></h3>
    <button
      mat-flat-button
      class="bticino-ico close round-button-with-background transparent-background"
      style="width: 40px; height: 40px"
      (click)="onCloseTooltip()"
    >
    </button>
  </div>
  <mat-accordion class="row d-flex flex-row flex-wrap justify-content-between expansion-panel-container m-b-row panel-description" [multi]="false" >
    <div class="expansion-panel-container d-inline-block m-b-45 w-100 m-w-accordion m-b-row">
      <mat-expansion-panel class="border p-t-20">
        <mat-expansion-panel-header>
          <mat-panel-title class="d-flex align-items-center">
            <h4>
              {{ "finishing.IDS_LIVINGNOW" | translate }}
            </h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="primary m-b-32 p-r-29">
          {{ "b2c.IDS_LIVINGNOWDESCRIPTIONLATERAL" | translate }}
        </p>
        <h5 class="primary">
          {{ "b2c.IDS_MATERIALS" | translate }}
        </h5>
        <div class="row d-flex flex-row flex-wrap m-b-40">
          <div class="row-item m-r-58 m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/materials/livingnow-zama.png" />
            <p class="text-center m-b-0">{{ "b2c.IDS_ZAMA" | translate }}</p>
          </div>
          <div class="row-item m-r-58 m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/materials/livingnow-tecnopolymer.png" />
            <p class="text-center m-b-0">{{ "b2c.IDS_TECNOPOLYMER" | translate }}</p>
          </div>
          <div class="row-item m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/materials/livingnow-wood.png" />
            <p class="text-center m-b-0">{{ "b2c.IDS_WOOD" | translate }}</p>
          </div>
        </div>
        <h5 class="primary">
          {{ "b2c.IDS_SWITCHCOVERS" | translate }}
        </h5>
        <div class="row d-flex flex-row flex-wrap m-b-footer">
          <div class="row-item m-r-58 m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/switches/livingnow-switch-white.png" />
            <p class="text-center m-b-0">{{ "b2c.IDS_SWITCHWHITE" | translate }}</p>
          </div>
          <div class="row-item m-r-58 m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/switches/livingnow-switch-sand.png" />
            <p class="text-center m-b-0">{{ "b2c.IDS_SWITCHSAND" | translate }}</p>
          </div>
          <div class="row-item m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/switches/livingnow-switch-black.png" />
            <p class="text-center m-b-0">{{ "b2c.IDS_SWITCHBLACK" | translate }}</p>
          </div>
        </div>
      </mat-expansion-panel>
    </div>

    <div class="expansion-panel-container d-inline-block m-b-45 w-100 m-w-accordion m-b-row">
      <mat-expansion-panel class="border p-t-20">
        <mat-expansion-panel-header>
          <mat-panel-title class="d-flex align-items-center">
            <h4>
              {{ "finishing.IDS_LIVINGLIGHT" | translate }}
            </h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="primary m-b-32 p-r-29">
          {{ "b2c.IDS_LIVINGLIGHTDESCRIPTIONLATERAL" | translate }}
        </p>
        <h5 class="primary">
          {{ "b2c.IDS_LINES" | translate }}
        </h5>
        <div class="row d-flex flex-row flex-wrap m-b-40">
          <div class="row-item m-r-58 m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/lines/livinglight-air.png" />
            <p class="text-center">{{ "b2c.IDS_AIR" | translate }}</p>
          </div>
          <div class="row-item m-r-58 m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/lines/livinglight-square.png" />
            <p class="text-center">{{ "b2c.IDS_SQUARE" | translate }}</p>
          </div>
          <div class="row-item m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/lines/livinglight-international.png" />
            <p class="text-center">{{ "b2c.IDS_TECNOPOLYMER" | translate }}</p>
          </div>
        </div>
        <h5 class="primary">
          {{ "b2c.IDS_MATERIALS" | translate }}
        </h5>
        <div class="row d-flex flex-row flex-wrap m-b-40">
          <div class="row-item m-r-58 m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/materials/livinglight-metal.png" />
            <p class="text-center">{{ "b2c.IDS_METAL" | translate }}</p>
          </div>
          <div class="row-item m-r-58 m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/materials/livinglight-wood.png" />
            <p class="text-center">{{ "b2c.IDS_WOOD" | translate }}</p>
          </div>
          <div class="row-item m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/materials/livinglight-tecnopolymer.png" />
            <p class="text-center">{{ "b2c.IDS_TECNOPOLYMER" | translate }}</p>
          </div>
        </div>
        <h5 class="primary">
          {{ "b2c.IDS_SWITCHES" | translate }}
        </h5>
        <div class="row d-flex flex-row flex-wrap m-b-footer">
          <div class="row-item m-r-58 m-b-24 w-163 d-flex flex-nowrap flex-column align-items-center">
            <img class="m-b-10" src="../../../assets/img/series/switches/livinglight-switch-white.png" />
            <p class="text-center">{{ "b2c.IDS_SWITCHWHITE" | translate }}</p>
          </div>
          <div class="row-item m-r-58 m-b-24 w-163 d-flex flex-nowrap flex-column align-items-center">
            <img class="m-b-10" src="../../../assets/img/series/switches/livinglight-switch-tech.png" />
            <p class="text-center">{{ "b2c.IDS_SWITCHTECH" | translate }}</p>
          </div>
          <div class="row-item m-b-24 w-163 d-flex flex-nowrap flex-column align-items-center">
            <img class="m-b-10" src="../../../assets/img/series/switches/livinglight-switch-black.png" />
            <p class="text-center">{{ "b2c.IDS_SWITCHANTRHACITE" | translate }}</p>
          </div>
        </div>
      </mat-expansion-panel>
    </div>

    <div class="expansion-panel-container d-inline-block m-b-45 w-100 m-w-accordion m-b-row" *ngIf="false">
      <mat-expansion-panel class="border p-t-20">
        <mat-expansion-panel-header>
          <mat-panel-title class="d-flex align-items-center">
            <h4>
              {{ "finishing.IDS_MATIX" | translate }}
            </h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="primary m-b-32 p-r-29">
          {{ "b2c.IDS_MATIXDESCRIPTIONLATERAL" | translate }}
        </p>
        <h5 class="primary">
          {{ "b2c.IDS_COLLECTIONS" | translate }}
        </h5>
        <p class="primary m-b-32 p-r-29">
          {{ "b2c.IDS_MATIXCOLLECTIONS" | translate }}
        </p>
        <div class="row d-flex flex-row flex-wrap m-b-40">
          <div class="row-item m-r-58 m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/materials/matix-white.png" />
            <p class="text-center">{{ "b2c.IDS_MATIXWHITE" | translate }}</p>
          </div>
          <div class="row-item m-r-58 m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/materials/matix-metallics.png" />
            <p class="text-center">{{ "b2c.IDS_MATIXMETTALICS" | translate }}</p>
          </div>
          <div class="row-item m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/materials/matix-galvanics.png" />
            <p class="text-center">{{ "b2c.IDS_MATIXGALVANICS" | translate }}</p>
          </div>
          <div class="row-item m-r-58 m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/materials/matix-texture.png" />
            <p class="text-center">{{ "b2c.IDS_MATIXTEXTURE" | translate }}</p>
          </div>
          <div class="row-item m-r-58 m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/materials/matix-colors.png" />
            <p class="text-center">{{ "b2c.IDS_MATIXCOLORS" | translate }}</p>
          </div>
        </div>
        <h5 class="primary">
          {{ "b2c.IDS_SWITCHES" | translate }}
        </h5>
        <div class="row d-flex flex-row flex-wrap m-b-footer">
          <div class="row-item m-r-58 m-b-24 w-163 d-flex flex-nowrap flex-column align-items-center">
            <img class="m-b-10" src="../../../assets/img/series/switches/matix-switch-white.png" />
            <p class="text-center">{{ "b2c.IDS_SWITCHWHITE" | translate }}</p>
          </div>
        </div>
      </mat-expansion-panel>
    </div>

    <div class="expansion-panel-container d-inline-block m-b-45 w-100 m-w-accordion m-b-row">
      <mat-expansion-panel class="border p-t-20">
        <mat-expansion-panel-header>
          <mat-panel-title class="d-flex align-items-center">
            <h4>
              {{ "finishing.IDS_MATIXGO" | translate }}
            </h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="primary m-b-32 p-r-29">
          {{ "b2c.IDS_MATIXGODESCRIPTIONLATERAL" | translate }}
        </p>
        <p class="primary m-b-32 p-r-29">
          {{ "b2c.IDS_MATIXGOCOLLECTIONS" | translate }}
        </p>
        <h5 class="primary">
          {{ "b2c.IDS_FINISHINGS" | translate }}
        </h5>
        <div class="row d-flex flex-row flex-wrap m-b-40">
          <div class="row-item m-r-58 m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/materials/matixgo-monocrome.png" />
            <p class="text-center">{{ "b2c.IDS_MATIXGOMONOCROME" | translate }}</p>
          </div>
          <div class="row-item m-r-58 m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/materials/matixgo-tones.png" />
            <p class="text-center">{{ "b2c.IDS_MATIXGOTONES" | translate }}</p>
          </div>
          <div class="row-item m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/materials/matixgo-effects.png" />
            <p class="text-center">{{ "b2c.IDS_MATIXGOEFFECTS" | translate }}</p>
          </div>
          <div class="row-item m-r-58 m-b-24">
            <img class="m-b-10" src="../../../assets/img/series/materials/matixgo-bio.png" />
            <p class="text-center">{{ "b2c.IDS_MATIXGOBIO" | translate }}</p>
          </div>
        </div>
        <h5 class="primary">
          {{ "b2c.IDS_SWITCHES" | translate }}
        </h5>
        <div class="row d-flex flex-row flex-wrap m-b-footer">
          <!--<div class="row-item m-r-58 m-b-24 w-163 d-flex flex-nowrap flex-column align-items-center">
            <img class="m-b-10" src="../../../assets/img/series/switches/matixgo-switch-white.png" />
            <p class="text-center">{{ "b2c.IDS_SWITCHWHITE" | translate }}</p>
          </div>-->
          <div class="row-item m-r-58 m-b-24 w-163 d-flex flex-nowrap flex-column align-items-center">
            <img class="m-b-10" src="../../../assets/img/series/switches/matixgo-switch-grey.png" />
            <p class="text-center">{{ "b2c.IDS_SWITCHWGREY" | translate }}</p>
          </div>
        </div>
      </mat-expansion-panel>
    </div>
  </mat-accordion>

</app-lateral-panel>